var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kstmod-debtpay-relatedlist"},[(_vm.access.Act_New)?[(!_vm.hideAction)?[_c('Action')]:[_c('kst-warning',{staticClass:"mb-4",attrs:{"items":_vm.debtPayWarning}})]]:_vm._e(),_c('Row',{attrs:{"access":_vm.access,"items":_vm.items}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }